import Model from '@/lib/data/Model';

class Rule extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'oper',
        'ref_table',
        'ref_action',
        'ref_id',
        'owner_id',
        'record_state', // persist in control_data_table_x_rule
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        // {
        //     name: 'saveRules',
        //     url: '/form/rule/save',
        //     associated: true
        // }
        // ,
        // {
        //     name: 'formDetailUpdate',
        //     url: '/mobile/visit/form/save',
        //     params: ['id', 'survey_info_id', 'values', 'l']
        // },
        // {
        //     name: 'create',
        //     url: '/forms/form',
        //     associated: true
        // },
        // {
        //     name: 'update',
        //     url: '/forms/form',
        //     associated: true
        // },
        // {
        //     name: 'destroy',
        //     url: '/forms/form',
        //     method: 'DELETE'
        // },
        // {
        //     name: 'saveQuestionsOrder',
        //     url: '/forms/form/questions/order',
        //     params: ['question_ids']
        // },
        // {
        //     name: 'saveSectionsOrder',
        //     url: '/forms/form/sections/order',
        //     params: ['sections_ids']
        // }
    ];
}

export default Rule;
